import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyBWcF4qgQuHB2hi0DFt1AKP3h45bCz3ZGk",
    authDomain: "slayers-api.firebaseapp.com",
    databaseURL: "https://slayers-api.firebaseio.com",
    projectId: "slayers-api",
    storageBucket: "",
    messagingSenderId: "790869803858"
};

const fire = firebase.initializeApp(config);
export default fire;


// WEBPACK FOOTER //
// ./src/conf/initFirebase.js